import React, { DetailedHTMLProps, SelectHTMLAttributes } from "react";

type ModalProps = {
  visible: boolean;
} & DetailedHTMLProps<SelectHTMLAttributes<HTMLDivElement>, HTMLDivElement>;

// NOTE: Not exactly an implementation
const Modal: React.FC<ModalProps> = ({ visible, children, ...rest }) => {
  return (
    visible && (
      <div className="fixed inset-0 z-20 overflow-y-auto">
        <div className="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
          <div className="fixed inset-0 transition-opacity duration-300 ease-out opacity-100">
            <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>
          {/* <!-- This element is to trick the browser into centering the modal contents. --> */}
          <span className="hidden sm:inline-block sm:align-middle sm:h-screen"></span>
          &#8203;
          <div
            className="inline-block overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
            role="dialog"
            aria-modal="true"
            {...rest}
          >
            {children}
          </div>
        </div>
      </div>
    )
  );
};

export default React.memo(Modal);
